import { BaseModel } from "../base-model";

export interface IMediaPubPlansArray {
    ObjectId: number;
    MediaPublicPlans: IMediaPubPlan[];
}

/**
 * Identity of a publish-plan row. Id alone is not enough (0 until saved), and neither is
 * MediaId + TypeOfPropId: a unit's "publish unit" row is filed under the property's main
 * TypeOfProp, so it shares all three with the main row and only IsMain separates them.
 * Keep every row lookup on this so the key cannot drift between call sites.
 */
export const isSamePubPlanRow = (a: IMediaPubPlan, b: IMediaPubPlan): boolean =>
    a.Id === b.Id && a.MediaId === b.MediaId && a.TypeOfPropId === b.TypeOfPropId && a.IsMain === b.IsMain;

export interface IMediaPubPlan {
  ObjectId: number;
  ParentObjectId: number;
  MediaId: number;
  MediaName: string;
  IsMain: boolean;
  TypeOfPropId: number;
  IsSelected: boolean;
  IsMediaSiteAutoUpdate: boolean;
  ItemState: number;
  Id: number;
  TypeOfPropInfo:ITypeOfProp;
  StartDate: string;
  EndDate: string;
  ViewDetailsIconUrl: string;
  ViewDetailsUrl: string;
  MediaCode: string;
  ImmowebStartDate: string;
  ImmowebEndDate: string;
  ImmowebOption: number;
  ImmowebDetailedPage: number;
  Score: string;
  PublishProjectOnPortal: number;
  PublishProjectInfo: any;
  UnitPublishType: number;
  IsPutAllProperties?: boolean;
  Index?: number;
  PortalName?: string;
}

export class MediaPubPlan extends BaseModel<IMediaPubPlan>
  implements IMediaPubPlan {
  ObjectId: number;
  ParentObjectId: number;
  MediaId: number;
  MediaName: string;
  IsMain: boolean;
  TypeOfPropId: number;
  IsSelected: boolean;
  IsMediaSiteAutoUpdate: boolean;
  ItemState: number;
  Id: number;
  TypeOfPropInfo:ITypeOfProp;
  StartDate: string;
  EndDate: string;
  ViewDetailsIconUrl: string;
  ViewDetailsUrl: string;
  MediaCode: string;
  ImmowebStartDate: string;
  ImmowebEndDate: string;
  ImmowebOption: number;
  ImmowebDetailedPage: number;
  Score: string;
  PublishProjectOnPortal: number;
  PublishProjectInfo: any;
  UnitPublishType: number;
  IsPutAllProperties?: boolean;
  Index?: number;
  constructor(option: any = {}) {
    super(option);

    // this.ObjectId = option.ObjectId;
    // this.ParentObjectId = option.ParentObjectId;
    // this.MediaId = option.MediaId;
    // this.MediaName = option.MediaName;
    // this.IsMain = option.IsMain;
    // this.TypeOfPropId = option.TypeOfPropId;
    // this.IsSelected = option.IsSelected;
    // this.IsMediaSiteAutoUpdate = option.IsMediaSiteAutoUpdate;
    // this.Id = option.Id;
    // this.StartDate = option.StartDate;
    // this.EndDate = option.EndDate;
    // this.ViewDetailsIconUrl = option.ViewDetailsIconUrl;
    // this.ViewDetailsUrl = option.ViewDetailsUrl;
    // this.MediaCode = option.MediaCode;
    // this.ImmowebStartDate = option.ImmowebStartDate;
    // this.ImmowebEndDate = option.ImmowebEndDate;
    // this.ImmowebOption = option.ImmowebOption;
    // this.Score = option.Score;
    // this.PublishProjectOnPortal = option.PublishProjectOnPortal;
    // this.PublishProjectInfo = option.PublishProjectInfo;
    // this.IsPutAllProperties = option.IsPutAllProperties;
  }
}


export interface ITypeOfProp {
    CategoryTypeId: number;
    IconUrl: string;
    NameEN: string;
    NameFR: string;
    NameNL: string;   
    ParentId: number;
    Id: number;
  }

